export class ForgotPasswordModel {
  email: string;
  isResetLinkSent?: boolean;
  toastMessage?: string;
  // Add more fields as needed

  constructor(email = "", isResetLinkSent = false, toastMessage = "") {
    this.email = email;
    this.isResetLinkSent = isResetLinkSent;
    this.toastMessage = toastMessage;
  }
}
